import camelCase from 'lodash/camelCase';
export const generateGruserObjectId = ({ gruserId, gruserTypeid, gruserItemid })=>{
    return `${gruserId}-${gruserTypeid}-${gruserItemid || 'null'}`;
};
export const getModuleDataFromPapiModule = (module)=>{
    const { moduleData } = module;
    const { dataKey = '' } = moduleData;
    return moduleData[camelCase(dataKey)] || {};
};
